import { render } from "./Lokation.vue?vue&type=template&id=3eb88cd2&scoped=true"
import script from "./Lokation.vue?vue&type=script&lang=js"
export * from "./Lokation.vue?vue&type=script&lang=js"

import "./Lokation.vue?vue&type=style&index=0&id=3eb88cd2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb88cd2"]])

export default __exports__